import React, { useRef, useEffect } from "react";
import { Form, message } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText, momentFormat } from "@/utils/utils";
import { useReportBillModel } from "../reportBillModel";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { reportBillService } from "../reportBillService";
import { getBaseImgLookUrl } from "@/utils/constants";
import { Image } from 'antd';
//结算
export function LogDrawer() {
    // 新增审批状态类型定义

    // 审批节点状态样式映射
    const statusStyles: any = {
        2: { color: '#52C41A', bgColor: '#52C41A', borderColor: 'rgba(82, 196, 26, 0.24)' },//审批通过
        8: { color: '#d82007', bgColor: '#F5222D', borderColor: 'rgba(245, 34, 45, 0.25)' },//审批驳回
        0: { color: '#FF9900', bgColor: '#FFC53D', borderColor: 'rgba(255, 197, 61, 0.3)' },//待处理
    };
    const { logVisible: visible, setLogVisible, selectedRow, } = useReportBillModel();

    // 新增：存储从服务器获取的详情数据
    const [detailData, setDetailData] = React.useState<any>({});
    // 新增：加载状态
    const [loading, setLoading] = React.useState(false);

    // 进入页面单条查询，获取数据填入
    useEffect(() => {
        if (visible && selectedRow?.id) {
            fetchDetail(selectedRow.id);
        }
    }, [visible, selectedRow?.id]);

    // 新增：获取详情数据的函数
    const fetchDetail = async (id: string) => {
        setLoading(true);
        const res = await reportBillService.one(id);
        setDetailData({
            ...res.retData,
            fileMsg: res.retData.fileMsg ? res.retData.fileMsg.split(",") : []
        })
        setLoading(false)
    }

    //监听批量录入字段
    const onChange = (changedValues: { [key: string]: any }) => {
        if ('isBatch' in changedValues) {
        }
    }

    const onCancel = () => {
        setLogVisible(false);
        setDetailData([])
    }
    const onOk = () => {
        setLogVisible(false);
        setDetailData([])
    }
    const onFinish = (val: any) => {

    }

    // 带标题的图片预览组件
    const ImagePreview: React.FC<{ url?: any; title: string }> = ({ url, title }) => {
        return (
            <div style={{ width: 'calc(50% - 16px)', boxSizing: 'border-box' }}>
                <Image
                    src={getBaseImgLookUrl(url)}
                    style={{ width: '180px', height: '140px', borderRadius: 4, border: '1px solid #e8e8e8' }}
                />
                <div style={{ textAlign: 'center', marginTop: 4, fontSize: 12, color: '#666' }}>
                    {title}
                </div>
            </div>
        );
    };

    // 新增：多张图片预览组件
    const MultiImagePreview: React.FC<{ urls?: string[]; alts?: string[] }> = ({ urls, alts }) => {
        return (
            <div style={{ margin: '8px 0', display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {urls?.map((url, index) => (
                    <div key={index} style={{ width: 'calc(33.333% - 7px)' }}>
                        <Image
                            src={getBaseImgLookUrl(url)}
                            alt={alts?.[index] || `图片${index + 1}`}
                            style={{ width: '120px', height: '120px', objectFit: 'cover', borderRadius: 4, border: '1px solid #e8e8e8' }}
                        />
                    </div>
                ))}
            </div>
        );
    }

    // 生成的审批节点
    const approvalNodes: any = detailData ? detailData.availNode : [];

    return (
        <YHDrawer
            {...{
                title: '审批进度',
                visible,
                cancelText: "返回",
                onCancel,
                width: 600,
                loading,
                onOk
            }}
        >
            {/* <YhForm {...formConfig} /> */}
            {/* 审批进度组件 */}
            <div style={{ marginTop: 24, padding: '0 24px' }}>


                <div style={{ position: 'relative', paddingLeft: 15 }}>
                    {approvalNodes?.map((node: any, index: any) => {
                        const { color, bgColor, borderColor } = statusStyles[node.adjustStatus];
                        const isLastNode = index === approvalNodes.length - 1;
                        const isActiveNode = node.adjustStatus === 2;

                        return (
                            <React.Fragment key={node.approvalId}>
                                {/* 节点内容 */}
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                                    <div
                                        style={{
                                            width: 20,
                                            height: 20,
                                            borderRadius: '50%',
                                            backgroundColor: bgColor,
                                            border: `2px solid ${borderColor}`,
                                            boxShadow: `0 0 0 2px ${borderColor}`,
                                            zIndex: 1
                                        }}
                                    />
                                    <div style={{ marginLeft: 15, flex: 1, color: node.adjustStatus === 0 ? '#999' : 'inherit' }}>
                                        <div style={{ fontSize: 18, fontWeight: node.adjustStatus !== 0 ? 600 : 500 }}>
                                            {node.approvalName}
                                        </div>
                                        <div style={{ fontSize: 17, color: '#666', marginTop: 4 }}>
                                            审批人：{node.adjustUser}
                                            <span style={{ marginLeft: 16 }}>审批时间：{momentFormat(node.adjustTime)}</span>
                                        </div>
                                        <div style={{ fontSize: 17, color, marginTop: 2, display: 'flex', alignItems: 'center' }}>
                                            审批结果：{node.adjustStatus == 2 ? "审核通过" : node.adjustStatus == 8 ? "审核驳回" : '待审核'}
                                        </div>
                                        {/* 修改：将备注移到下一行 */}
                                        {node.approvalOpinion && (
                                            <div style={{ fontSize: 16, color: '#999', marginTop: 2, display: 'flex', alignItems: 'center' }}>
                                                备注：{node.approvalOpinion}
                                            </div>
                                        )}
                                        {node.signatureMsg &&
                                            <div style={{ fontSize: 17, color: '#666', marginTop: 2, display: 'flex', alignItems: 'center' }}>
                                                签名：                                      <Image
                                                    src={getBaseImgLookUrl(node.signatureMsg)}
                                                    alt="审批签名"
                                                    style={{ width: 120, height: 60, objectFit: 'contain', border: '1px solid #e8e8e8' }}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>

                                {/* 连接线（最后一个节点不显示） */}
                                {!isLastNode && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            left: 23,
                                            top: 80 + index * 80,
                                            width: 2,
                                            height: 80,
                                            backgroundColor: index === 0 ? '#E8E8E8' : (isActiveNode ? '#FFC53D' : '#E8E8E8'),
                                            opacity: index === 0 ? 0.5 : 1,
                                            zIndex: 0
                                        }}
                                    ></div>
                                )
                                }
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </YHDrawer >
    )
}    